/* "Ask us a question" (Fix 8) — snippets/pdp-ask-modal.liquid + pdp-ask-button.liquid.
   Every .mm-ask-cta__btn (after the buy-box FAQs, and under the video popup's
   deck) opens one shared contact-form popup. Motion runs on mm-spring.js: a
   bottom sheet under 700px (swipe down to close), a centred card above it.
   Without MMSpring the popup simply shows and hides. */
(function () {
  'use strict';
  if (window.__mmAskInit) return;
  window.__mmAskInit = true;

  var KEY = 'mmAsk';                       // sessionStorage: survives the /contact round trip
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var MESSAGES = {
    name: 'Enter your name',
    email: 'Enter a valid email so we can reply',
    body: 'Type your question'
  };
  var SOURCES = {
    'buybox': 'Buy box',
    'video-popup': 'Video popup'
  };
  var sheetMq = window.matchMedia('(max-width: 699px)');
  var fineMq = window.matchMedia('(pointer: fine)');

  var root, panel, scrim, form;
  var isOpen = false, motion = null, motions = {}, trigger = null, pausedVideo = null, prevOverflow = '';

  function field(key) { return form.querySelector('[data-mm-ask-field="' + key + '"]'); }

  /* ── Tracking. Clicks and sends go to GA4 (gtag, once consent has loaded it),
     the GTM dataLayer and Shopify customer events — all fail-silent:
       ask_question_open   { placement }   a trigger was clicked
       ask_question_submit { placement }   a valid question was sent
       endcard_video_click { placement }   a gallery end-card video was tapped
     Each message also carries the visitor's UTMs / click IDs from mm_attr
     (mm-tracking.liquid), falling back to this page's own query string. ── */
  var placement = '';
  function track(name, where) {
    var data = { placement: where || placement || 'unknown', product: (form.querySelector('[name="contact[Product]"]') || {}).value || '' };
    try { if (typeof window.gtag === 'function') window.gtag('event', name, data); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'mm_' + name, mm_ask: data }); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
  }

  var ATTR_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id',
    'fbclid', 'gclid', 'ttclid', 'msclkid'];
  function trafficSource() {
    var attr = null;
    try { attr = JSON.parse(localStorage.getItem('mm_attr') || 'null'); } catch (e) {}
    var touch = (attr && (attr.last || attr.first)) || {};
    var q = new URLSearchParams(window.location.search);
    var out = [];
    ATTR_KEYS.forEach(function (k) {
      var v = q.get(k) || touch[k];
      if (v) out.push(k + '=' + String(v).slice(0, 120));
    });
    if (!out.length && touch.ref) out.push('referrer=' + String(touch.ref).slice(0, 120));
    return out.join(' | ') || 'direct / none';
  }

  function showView(name) {
    root.querySelectorAll('[data-mm-ask-view]').forEach(function (v) {
      v.hidden = v.getAttribute('data-mm-ask-view') !== name;
    });
    panel.setAttribute('aria-labelledby', name === 'done' ? 'mm-ask-done-title' : 'mm-ask-title');
  }

  // One spring per layout, made on first use: the sheet slides on a px spring,
  // the card fades/scales (and swipes down) on MMSpring.modal.
  function getMotion() {
    if (!window.MMSpring) return null;
    var mode = sheetMq.matches ? 'sheet' : 'card';
    if (!motions[mode]) {
      motions[mode] = mode === 'sheet'
        ? MMSpring.panel(panel, { side: 'bottom', preset: MMSpring.PRESETS.modal, scrim: scrim, onDismiss: close, onClosed: hide })
        : MMSpring.modal(panel, { scrim: scrim, onDismiss: close, onClosed: hide });
    }
    return motions[mode];
  }

  function hide() { if (!isOpen) root.hidden = true; }

  function open(src, btn, done) {
    if (isOpen) return;
    trigger = btn || null;
    var srcField = form.querySelector('[data-mm-ask-src-field]');
    if (srcField && src) srcField.value = SOURCES[src] || src;
    if (src) { placement = src; track('ask_question_open'); }
    showView(done ? 'done' : 'form');

    // Opened from the video popup: pause its footage, resume on close. The
    // video popup itself stays open underneath.
    pausedVideo = null;
    var vcModal = btn && btn.closest('[data-mm-vc-modal]');
    var v = vcModal && vcModal.querySelector('.mm-vc__slide--active video');
    if (v && !v.paused) { v.pause(); pausedVideo = v; }

    // Last child of <body>: wins the z-index tie with the cart drawer, sits over the video popup
    if (root.parentNode !== document.body || document.body.lastElementChild !== root) {
      document.body.appendChild(root);
    }
    root.hidden = false;
    prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    isOpen = true;
    motion = getMotion();
    if (motion) motion.open(); // reopened mid-close: reverses from where it is

    // Desktop lands in the first field; touch focuses the sheet so the keyboard doesn't jump up
    var first = done ? root.querySelector('#mm-ask-done-title') : (fineMq.matches ? field('name') : panel);
    if (first) first.focus({ preventScroll: true });
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    document.body.style.overflow = prevOverflow;
    if (motion) motion.close(); else hide(); // hidden once the spring settles
    if (pausedVideo) {
      var v = pausedVideo;
      pausedVideo = null;
      if (v.isConnected) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    }
    if (trigger && trigger.isConnected) trigger.focus({ preventScroll: true });
    trigger = null;
  }

  /* ── Validation: inline, per field. Errors show on submit; after that a
     field re-checks as it's fixed. Blur checks anything already typed. ── */
  function check(key) {
    var el = field(key);
    if (!el) return true;
    var val = el.value.trim();
    var ok = key === 'email' ? EMAIL_RE.test(val) : val.length > 0;
    var err = document.getElementById(el.getAttribute('aria-describedby'));
    el.setAttribute('aria-invalid', ok ? 'false' : 'true');
    if (err) { err.textContent = ok ? '' : MESSAGES[key]; err.hidden = ok; }
    return ok;
  }

  function wireForm() {
    ['name', 'email', 'body'].forEach(function (key) {
      var el = field(key);
      if (!el) return;
      el.addEventListener('input', function () { if (el.getAttribute('aria-invalid') === 'true') check(key); });
      el.addEventListener('blur', function () { if (el.value.trim()) check(key); });
    });

    // On the button click (Enter in a field triggers it too), so an invalid
    // attempt never reaches Shopify's spam-protection hook on submit.
    var submit = form.querySelector('.mm-ask__submit');
    if (submit) {
      submit.addEventListener('click', function (e) {
        var bad = ['name', 'email', 'body'].filter(function (key) { return !check(key); });
        if (bad.length) {
          e.preventDefault();
          field(bad[0]).focus();
          return;
        }
        // The page reloads on /contact's redirect — remember where to put the
        // shopper back (the video popup's scroll lock parks the page at top:-y).
        var utm = form.querySelector('[data-mm-ask-utm-field]');
        if (utm) utm.value = trafficSource();
        track('ask_question_submit');
        var y = document.body.style.position === 'fixed'
          ? -parseInt(document.body.style.top || '0', 10)
          : (window.scrollY || window.pageYOffset || 0);
        try { sessionStorage.setItem(KEY, JSON.stringify({ email: field('email').value.trim(), y: y })); } catch (err) {}
      });
    }
  }

  // Back from /contact: reopen on the thank-you (or on the form, with Shopify's errors).
  function resume() {
    var saved = null;
    try { saved = JSON.parse(sessionStorage.getItem(KEY) || 'null'); sessionStorage.removeItem(KEY); } catch (e) {}
    if (!saved) return;
    var posted = /[?&]contact_posted=true/.test(window.location.search);
    if (!posted && !root.querySelector('[data-mm-ask-server-err]')) return;
    if (posted && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.delete('contact_posted');
      url.hash = '';
      window.history.replaceState(window.history.state, '', url.pathname + url.search);
    }
    if (saved.y) window.scrollTo({ top: saved.y, left: 0, behavior: 'instant' });
    var email = root.querySelector('[data-mm-ask-email]');
    if (posted && email && saved.email) email.textContent = saved.email;
    open('', null, posted);
  }

  function init() {
    root = document.querySelector('[data-mm-ask-modal]');
    if (!root) return;
    panel = root.querySelector('.mm-ask__panel');
    scrim = root.querySelector('.mm-ask__scrim');
    form = root.querySelector('form');
    if (!panel || !form) return;

    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('.mm-hero__endcard-reel')) { track('endcard_video_click', 'gallery-endcard'); return; }
      var btn = e.target.closest('.mm-ask-cta__btn');
      if (!btn) return;
      e.preventDefault();
      var wrap = btn.closest('[data-mm-ask-src]');
      open(wrap ? wrap.getAttribute('data-mm-ask-src') : '', btn);
    });

    root.querySelectorAll('[data-mm-ask-close]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); close(); });
    });
    var doneBtn = root.querySelector('.mm-ask__done-btn');
    if (doneBtn) doneBtn.addEventListener('click', function (e) { e.preventDefault(); close(); });

    // Window capture: runs before the video popup's document listener, so Esc
    // closes only this popup and ←/→ move the caret instead of the video deck.
    window.addEventListener('keydown', function (e) {
      if (!isOpen) return;
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(); return; }
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.stopPropagation(); return; }
      if (e.key !== 'Tab') return;
      // Focus trap
      var list = Array.prototype.filter.call(
        panel.querySelectorAll('button, [href], input:not([type="hidden"]), textarea, select, [tabindex]:not([tabindex="-1"])'),
        function (el) { return !el.disabled && el.offsetParent !== null; }
      );
      if (!list.length) return;
      var firstEl = list[0], lastEl = list[list.length - 1], at = document.activeElement;
      if (e.shiftKey && (at === firstEl || !panel.contains(at) || at === panel)) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && (at === lastEl || !panel.contains(at))) { e.preventDefault(); firstEl.focus(); }
    }, true);

    wireForm();
    resume();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
